import styled from '@emotion/styled';
import React from 'react';
import Lottie from 'react-lottie-player';

import { useTranslation } from 'react-i18next';
import loadingAnimation from 'src/public/animations/loader.json';
import { color, font } from 'src/shared/styles/variables';

const Wrapper = styled.div({
    backgroundColor: color.rhino,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
});

const HeadingText = styled.h2(
    {
        color: color.white,
        margin: 0,
        marginBottom: '20px',
    },
    font.black(font.size.extraLarge),
);

const DescriptionText = styled.p(
    {
        color: color.white,
        marginBottom: 100,
    },
    font.book(font.size.medium),
);

const LoadingAnimation = styled(Lottie)({
    width: 200,
});

export const ModalityLoader = () => {
    const { t } = useTranslation();

    return (
        <Wrapper>
            <LoadingAnimation animationData={loadingAnimation} loop speed={0.6} play />
            <HeadingText>{t('onboarding:onboarding_thank_you_page.title')}</HeadingText>
            <DescriptionText>
                {t('onboarding:onboarding_thank_you_page.description')}
            </DescriptionText>
        </Wrapper>
    );
};
